package com.sddamico.swigmore.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** Where a team stood in a published poll. */
@Serializable
sealed interface PollStanding {
  @Serializable
  @SerialName("ranked")
  data class Ranked(val rank: Int) : PollStanding

  /** Outside the top [PollRules.BALLOT_SIZE] but on at least one ballot. */
  @Serializable
  @SerialName("receiving-votes")
  data object ReceivingVotes : PollStanding

  @Serializable
  @SerialName("unranked")
  data object Unranked : PollStanding

  companion object {
    /** [rank] is the tallied rank, or null for a team on no ballot. */
    fun of(rank: Int?): PollStanding = when {
      rank == null -> Unranked
      rank <= PollRules.BALLOT_SIZE -> Ranked(rank)
      else -> ReceivingVotes
    }
  }
}
